/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
const Modal = React.lazy(() => import('@web-components/common/Modal'));
const Button = React.lazy(() => import('@web-components/form/Button'));
import { requestToDeleteReview } from '~store/product-detail/thunks';
import { unwrapResult } from '@reduxjs/toolkit';
import Toast from 'react-native-toast-message';

const ModalRequestToDeleteReview = (props) => {
  const dispatch = useDispatch();
  const isShow = useSelector(
    (state) => state.modal.requestToDeleteReview.isShow,
  );
  const review = useSelector((state) => state.modal.requestToDeleteReview.data);
  // eslint-disable-next-line no-unused-vars
  const statusApiRequestToDeleteReview = useSelector(
    (state) => state.productDetail.status.requestToDeleteReview,
  );

  const closeModal = async () => {
    await dispatch({ type: 'MODAL/HIDE', modalName: 'requestToDeleteReview' });
  };

  const deleteReview = async () => {
    const id = review.newsfeed_id;
    try {
      const resultAction = await dispatch(requestToDeleteReview(id));
      // eslint-disable-next-line no-unused-vars
      const response = unwrapResult(resultAction);
      Toast.show({ text1: 'Request untuk menghapus telah dikirim' });
      closeModal();
    } catch (err) {
      closeModal();
    }
  };

  return (
    <Modal
      overlayStyle={{ width: 328 }}
      isVisible={isShow}
      onBackdropPress={closeModal}
      onClose={closeModal}>
      <View style={styles.modalContainer}>
        <View style={styles.modalHeader}>
          <Text style={styles.modalHeaderHeading}>Request to Delete</Text>
        </View>

        <View>
          <Text style={[styles.modalText, { marginBottom: 20 }]}>
            Apakah kamu ingin menghapus review ini?
          </Text>

          <View style={styles.groupButton}>
            <Button
              buttonStyle={styles.buttonStyle}
              title="No"
              onPress={closeModal}
            />
            <Button
              buttonStyle={styles.buttonStyleCancel}
              titleStyle={styles.titleStyleCancel}
              title="Delete Review"
              onPress={deleteReview}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  buttonStyle: {
    width: 138,
    marginRight: 8,
  },
  buttonStyleCancel: {
    width: 138,
    backgroundColor: '#FFFFFF',
    marginLeft: 8,
  },
  titleStyleCancel: {
    color: '#25182E',
  },
  groupButton: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  modalContainer: {
    paddingHorizontal: 16,
    paddingBottom: 24,
    paddingTop: 20,
  },
  modalHeader: {
    position: 'relative',
    marginBottom: 16,
  },
  modalHeaderHeading: {
    fontFamily: 'satoshi-black',
    fontSize: 17,
    lineHeight: 23,
    color: '#25182E',
  },
  modalText: {
    fontFamily: 'satoshi-medium',
    fontSize: 13,
    lineHeight: 23,
    color: '#25182E',
    marginBottom: 15,
  },
});

export default ModalRequestToDeleteReview;
